import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ToastConfig } from '../types';

interface ToastState {
  toasts: ToastConfig[];
}

const initialState: ToastState = {
  toasts: [],
};

export const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    addToast: (state, action: PayloadAction<ToastConfig>) => {
      if (state.toasts.length >= 5) {
        state.toasts.shift(); // Remove oldest toast (FIFO)
      }
      state.toasts.push(action.payload);
    },
    removeToast: (state, action: PayloadAction<string>) => {
      state.toasts = state.toasts.filter((toast) => toast.id !== action.payload);
    },
  },
});

export const { addToast, removeToast } = toastSlice.actions;

export default toastSlice;
